import React, { useState } from 'react'
import { useAuthContext } from '../context/authContext'
import { Navigate } from "react-router-dom"
const useLogin = () => {
    const [loading, setLoading] = useState(false)
    const { setAuthUser } = useAuthContext();

    const login = async (username, password) => {
        setLoading(true)

        try {
            const res = await fetch("/api/auth/login", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username: username, password: password })
            })
            const body = await res.json()
            if (body.error) return body

            //localStorage
            localStorage.setItem('authUser', JSON.stringify(body))
            //context
            setAuthUser(body)
            Navigate({
                to: "/"
            })


        } catch (error) {
            console.log("Error ", error);

        } finally {
            setLoading(false)
        }
    }
    return [loading, login]
}

export default useLogin
